<template>
<div class="test-content">
<div class="check-symptoms-content">
    <div class="full-logo-white">
        <img src="/images/medik/white-logo.png" alt="medik-logo">
    </div>
    <div class="check-symptoms-text">
        <p>
            Identifikujte moguće uslove i tretman
            koji su povezani sa vašim simptomima.
        </p>
        <p>
            Ovaj alat ne pruža medicinske savete. Pogledajte dodatne informacije.
        </p>
    </div>
    <div class="basic-info">
        <div class="basic-info-age">
            <p>Godine</p>
            <input v-model="ageInput" type="text" id="age-input" maxlength="2" />
        </div>
        <div class="basic-info-gender">
            <p>Pol</p>
            <button 
                type="button" 
                class="gender-btn"
                @click="onGenderChange('male')"
                v-bind:class="{ selected: gender === 'male' }">
                Muški
            </button>
            <button 
                type="button" 
                class="gender-btn"
                @click="onGenderChange('female')"
                v-bind:class="{ selected: gender === 'female' }">
                Ženski
            </button>
        </div>
    </div>
</div>
</div>
</template>

<script>

export default {
    name: 'FirstStepInfo',
    components: {
    },

    props: ['age', 'gender'],

    data(){
        return {
        ageInput: this.age,
        }
    },

    methods: {
        onGenderChange: function(gender) {
        this.$emit('genderChange', gender);
        }
    },

    async created() {
        mixpanel.track("Start check-symptoms test");
    },

    watch: {
        ageInput: function(val, oldVal) {
            this.$emit('ageChange', val);
        }
    }
  
}
</script>

<style>
</style>